import React from 'react';
import { Link } from 'react-router-dom';
import stackedLogo from '../assets/playmaker-logo-stacked-w-tag.png';

const MobileHeader = ({ user, toggleMobileMenu, mobileMenuOpen, backLink = null }) => {
  return (
    <div className="mobile-header">
      {backLink ? (
        <Link to={backLink} className="mobile-menu-toggle">
          <i className="fa fa-arrow-left"></i>
        </Link>
      ) : (
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          style={{
            backgroundColor: '#F7F7F7',
            border: '1px solid #EEEEEE',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px'
          }}
        >
          <i className={`fa ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`} style={{
            fontSize: '1.1rem'
          }}></i>
        </button>
      )}
      
      <div className="mobile-logo">
        <img src={stackedLogo} alt="PlayMaker Pics" />
      </div>
      
      <div className="mobile-user">
        <div className="avatar">
          {user?.user_metadata?.avatar_url ? (
            <img src={user.user_metadata.avatar_url} alt="User avatar" />
          ) : (
            <div className="avatar-placeholder">
              {(user?.user_metadata?.given_name?.[0] || user?.email?.[0] || 'U').toUpperCase()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader; 